import { BlackCat } from "./BlackCat";

export const Quatrefoil = ({ size = 14, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    className={className} data-testid="quatrefoil-ornament" aria-hidden="true">
    <path d="M12 3c2.2 3 2.2 5.2 0 7-2.2-1.8-2.2-4 0-7Z" stroke="#581313" strokeWidth="1.2" />
    <path d="M12 21c-2.2-3-2.2-5.2 0-7 2.2 1.8 2.2 4 0 7Z" stroke="#581313" strokeWidth="1.2" />
    <path d="M3 12c3-2.2 5.2-2.2 7 0-1.8 2.2-4 2.2-7 0Z" stroke="#581313" strokeWidth="1.2" />
    <path d="M21 12c-3 2.2-5.2 2.2-7 0 1.8 2.2 4 2.2 7 0Z" stroke="#581313" strokeWidth="1.2" />
    <circle cx="12" cy="12" r="1.3" fill="#581313" />
  </svg>
);

// Divider crowned by the keeper's cat, sitting on the rule like a familiar on a ledge
export const TraceryDivider = ({ cat }) => (
  <div className="relative z-10 flex items-end gap-6 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-testid="tracery-divider" aria-hidden="true">
    <span className="flex-1 h-px bg-[#232530]" />
    <BlackCat pose={cat} size={46} inline className="-mb-1" />
    <span className="flex-1 h-px bg-[#232530]" />
  </div>
);
